/**
 * Color Scheme Hook (Web)
 *
 * Web-specific implementation of color scheme detection.
 * Uses ThemeProvider context for browser-based theming with NativeWind.
 * @module hooks/useColorScheme.web
 */
import { useTheme } from "@/providers/ThemeProvider";

// NOTE: The default React Native styling doesn't support server rendering.
// Server rendered styles should not change between the first render of the HTML
// and the first render on the client. Typically, web developers will use CSS media queries
// to render different styles on the client and server, these aren't directly supported in React Native
// but can be achieved using a styling library like Nativewind.

/**
 * Returns the resolved theme (light/dark) for web platform
 *
 * This web-specific implementation ensures consistent theming behavior
 * between server-rendered and client-rendered content.
 * @returns The resolved theme value from ThemeProvider
 */
export function useColorScheme() {
  const theme = useTheme();
  return theme.resolvedTheme;
}
